import React from 'react'
import { Grid } from '@material-ui/core'
import { Bar } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'

import * as Utils from 'src/utils/chartsUtils'
import TableAAA from '../../Tables/TableAAA'
import TableAAPP from '../../Tables/TableAAPP'

const MEITotalSalesCard = props => {
  const {
    table1a,
    table1b,
    gTotal1,
    selectedDate,
    totalSellInRegion,
    totalSellOutRegion,
    gATotalTerritory,
    gBTotalTerritory,
    totalbyTerritory,
  } = props

  return (
    <Card>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={6}>
            <div>
              <h3>SELL IN</h3>
            </div>
            <TableAAA array={table1a} selectedDate={selectedDate} param="MES" />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <div>
              <h3>SELL OUT</h3>
            </div>
            <TableAAA array={table1b} selectedDate={selectedDate} param="MES" />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <div>
              <h3>SELL IN </h3>
            </div>
            <TableAAPP array={totalSellInRegion} selectedDate={selectedDate} param="CATEGORIA" colParam />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <div>
              <h3>SELL OUT</h3>
            </div>
            <TableAAPP array={totalSellOutRegion} selectedDate={selectedDate} param="CATEGORIA" colParam />
          </Grid>
          <br />
          <Grid item xs={12} sm={12} lg={12}>
            <div>
              <h3>SELL IN POR ZONAS</h3>
            </div>
            <TableAAPP array={totalbyTerritory} selectedDate={selectedDate} param="TERRITORIO" colParam />
          </Grid>
          <Grid item xs={12} sm={12} lg={5}>
            <h3>Sell in MEI</h3>
            <br />
            <Bar
              data={Utils.simpleBarLine(gTotal1, 'Y', 'CANT', '', 'Año')}
              options={Utils.optionsSimpleBarChart}
            />{' '}
          </Grid>
          <Grid item xs={12} sm={12} lg={7}>
            <h3>Mix por zonas - años</h3>
            <br />
            <Bar
              data={Utils.customBarLineDataGroup(gATotalTerritory, 'TERRITORIO', 'PORCENTAJE', 'Y', '100')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <h3>Mix por zonas - mes</h3>
            <br />
            <Bar
              data={Utils.customBarLineDataGroup(gBTotalTerritory, 'TERRITORIO', 'PORCENTAJE', 'MESC', '100')}
              options={Utils.optionsGroupedCharts}
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default MEITotalSalesCard
